/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
//import { observer } from 'mobx-react';
import { Checkbox, Label } from 'semantic-ui-react';
import cx from 'classnames';
import searchIcon from '../../images/components/contnets_header/searchIcon.png';
import filterIcon from '../../images/components/contnets_header/filter icon.png';
import deleteIcon from '../../images/components/contnets_header/delete-icon-red.svg';
import progress from '../../images/icons/progress_ica.gif';

class SystemsSubHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      isLoadingWithSync: props.isLoadingWithSync,
      checkValue: [],
      //radioValue: 'active',
      errSearch: false,
      //isFocus: false,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    //this.handleFocus = this.handleFocus.bind(this);
    //this.handleBlur = this.handleBlur.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.handleAddNewLDAP = this.handleAddNewLDAP.bind(this);
    this.handleDeleteLDAP = this.handleDeleteLDAP.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    const {
      checkValue,
    } = this.state;
    const { filter, isLoadingWithSync } = this.props;
    const filterLength = filter.length;

    if (isLoadingWithSync !== prevProps.isLoadingWithSync) {
      this.setState({
        isLoadingWithSync,
      });
    }

    if (filter && prevProps.filter !== filter) {
      if (filterLength !== checkValue.length) {
        this.setState({
          checkValue: filter,
        });
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleSearch(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
            //isFocus: false,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
                //isFocus: true,
              });
            }, 1500);
          }
        );
        return false;
      }
      setTimeout(() => {
        this.setState({
          //isFocus: false,
        });
      }, 1500);
      this.props.onChangeSearch(event.target.value);
    }
  }

  handleClickOutside(event) {
    if (this.toggleBtn && !this.toggleBtn.contains(event.target)) {
      this.setState({
        visible: false,
      });
    }
  }

  handleCheckChange(e, { value }) {
    const { checkValue } = this.state;
    let newState;
    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }
    this.setState({
      checkValue: newState,
    });
  }

  handleDeleteLDAP() {
    this.props.handleDeleteLDAP();
  }

  handleAddNewLDAP() {
    this.props.handleAddNewLDAP();
  }

  handleActiveSync = () => {
    this.props.handleActiveSync();
  };

  onSubmit() {
    const { checkValue } = this.state;

    this.setState({
      visible: false,
    });

    this.props.onSubmit(
      { filter: checkValue, }
    );
  }

  toggleMenu() {
    const { visible } = this.state;
    this.setState({
      visible: !visible,
    });
  }

  closeMenu() {
    this.setState({
      visible: false,
    });
  }

  clearSearch() {
    this.search.value = '';
    this.props.clearSearch();
  }

  render() {
    const { checkValue, errSearch, isLoadingWithSync } = this.state;
    const { translate } = this.props;

    return (
      <div className="contents_header" style={{ minWidth: '1080px', width: '1080px' }}>
        <div className="contents_header_inner">
          <h2 className="page_title" style={{ float: 'left' }}>LDAP List</h2>
          <div className="util_wrap">
            <div className="util_item ">
              <div className="search_files_wrap">
                <img src={searchIcon} alt="" className="icon" />
                <input
                  type="search_files"
                  className="seach_text"
                  placeholder="Name, Host, Base DN, Filter"
                  ref={(ref) => {
                    this.search = ref;
                  }}
                  onKeyPress={this.handleSearch}
                />
                <a className="reset_icon" onClick={this.clearSearch}>
                  x
                </a>
                {errSearch && (
                  <Label basic color="red" pointing>
                    {translate('contents_header.message.least_two_required_to_search')}
                  </Label>
                )}
              </div>
            </div>
            <div
              className="util_item common_filter_toggle_button"
              ref={(element) => {
                this.toggleBtn = element;
              }}
            >
              <a className="util_button icon_button" onClick={this.toggleMenu}>
                <img src={filterIcon} alt="" />
              </a>
              <div
                className={cx('common_filter', {
                  hide: !this.state.visible,
                })}
                style={{
                  height: '175px',
                }}
              >
                <div className="common_filter_header">
                  <h2>{translate('contents_header.menu.filter_by')}</h2>
                </div>
                <div className="common_filter_contents_inner">
                  <div className="common_filter_item">
                    <p className="title">{translate('system.list.ldap_usage')}</p>
                    <div className="checkbox_wrap">
                      <ul>
                        <li>
                          <Checkbox
                            label="On"
                            value="on"
                            checked={checkValue.indexOf('on') > -1}
                            onChange={this.handleCheckChange}
                          />
                        </li>
                        <li style={{ marginBottom: '8px' }}>
                          <Checkbox
                            label="Off"
                            value="off"
                            checked={checkValue.indexOf('off') > -1}
                            onChange={this.handleCheckChange}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="common_filter_footer">
                  <a className="cancel_button" onClick={this.closeMenu}>
                    {translate('modal.button.cancel')}
                  </a>
                  <a className="apply_button" onClick={this.onSubmit}>
                    {translate('modal.button.apply')}
                  </a>
                </div>
              </div>
            </div>
            <div className="button_wrap util_item">
              {
                isLoadingWithSync ? (
                  <a
                    className="gray_button util_button"
                    style={{ pointerEvents: 'none' }}
                  >
                    <img
                      src={progress}
                      role="presentation"
                      style={{
                        width: 14,
                        height: 14,
                      }}
                      alt=""
                    />
                  </a>
                ) : (
                  <a
                    className="gray_button util_button"
                    onClick={this.handleActiveSync}
                    style={{ cursor: 'pointer' }}
                  >
                    {translate('modal.button.apply')}
                  </a>
                )
              }
              <a
                className="delete_button util_button"
                onClick={this.handleDeleteLDAP}
                style={{ cursor: 'pointer' }}
              >
                <span>
                  <img src={deleteIcon} alt="" style={{ width: '12px' }} />
                </span>
                {translate('system.button.delete')}
              </a>
              <a
                className="add_button util_button"
                onClick={this.handleAddNewLDAP}
                style={{ cursor: 'pointer' }}
              >
                <span>+</span>
                {translate('system.button.add')}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SystemsSubHeader;
SystemsSubHeader.defaultProps = {
  filter: [],
};
